import './home'
import './singleProjet'
import './projetsArchive'
import './entry-header'
import './service'
import './konami'
import './404'

$('.back_to_top').click(function () {
    $("html, body").animate({scrollTop: 0}, 400);
})
